
import { useRef, useState } from "react";
import Viewer from "./Viewer";

if (!Array.isArray(window.modelViewerMessages)) {
  window.modelViewerMessages = [];
}

const FrontEnd = ({ attributes }) => {
  const [modelReader, setModelReader] = useState(null);
  function __(text, textdomain = "") {
    return text;
  }
  const viewerRef = useRef();
  window.modelViewerMessages.push({ attributes, viewerRef });

  if (attributes) {
    return <Viewer {...{ attributes, viewerRef, __, modelReader, setModelReader }} />;
  }
};

export default FrontEnd;

